import { ReactNode } from "react";

export type SeoSectionContent = {
  about: ReactNode;
  whenToUse: string[];
  howItWorks: { title: string; desc: string }[];
  whatToAvoid: string[];
  tips: string[];
  /** Optional heading override for "About This Tool" */
  aboutHeading?: string;
};

/**
 * Renders the mandatory SEO content blocks every ReadBarcode tool/page
 * must include: About, When To Use, How It Works, What To Avoid, Tips.
 * Supported Barcode Types, FAQ and Related Tools stay on each page so
 * the content is unique per tool — this component only handles the
 * five blocks that share the same shape.
 *
 * Output is flat children of #mv-content (h2, p, ul, ol): `about` must be
 * one or more <p> elements.
 */
export function ToolSeoSections({
  about,
  aboutHeading = "About this tool",
  whenToUse,
  howItWorks,
  whatToAvoid,
  tips,
}: SeoSectionContent) {
  return (
    <>
      <h2>{aboutHeading}</h2>
      {about}

      <h2>When to Use It</h2>
      <ul>
        {whenToUse.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>

      <h2>How It Works</h2>
      <ol>
        {howItWorks.map((s, i) => (
          <li key={i}>
            <strong>{s.title}</strong>
            {` ${s.desc}`}
          </li>
        ))}
      </ol>

      <h2>What to Avoid</h2>
      <ul>
        {whatToAvoid.map((w, i) => (
          <li key={i}>{w}</li>
        ))}
      </ul>

      <h2>Tips &amp; Tricks</h2>
      <ul>
        {tips.map((t, i) => (
          <li key={i}>{t}</li>
        ))}
      </ul>
    </>
  );
}
